import ValidService from "../../../../../service/ValidService";

let model = {};

// dữ liệu form
model.dataForm = {};

// validation form
model.validForm = {};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 20,
  offset: 0,
  sort: "-time",
  defaultSort: ["time", "descending"],
  filters: "",
  recordSelected: [],
  dataSearchSalaryPeriod: {
    value: {
      salary_period_id: "",
    },
    valid: {
      salary_period_id: [],
    },
    operator: {
      salary_period_id: "",
    }
  },
  dataSearch: {
    value: {
      // text_search: "",
      employee_no: "",
      start_time: "",
      end_time: ""
    },
    valid: {
      employee_no: [],
      start_time: [ValidService.required],
      end_time: [ValidService.required]
    },
    operator: {
      // text_search: "",
      employee_no: "",
      start_time: "",
      end_time: ""
    }
  }
};

export default model;
